import { Radio } from "@mui/material";
import React, { useCallback } from "react";
import { FlatList, TouchableOpacity, Text, View, StyleSheet } from "react-native";
import { Badge } from "react-native-elements";
import EmptyListCompnoent from "../../../../common/component/EmptyListComponent";
import { FONT_FAMILY, THEME_COLORS } from "../../../../common/themes";

interface STListingProps {
  data: any[];
  selected: { id: number; fullName: string };
  onSelect: (id: number | string) => void;
  suggested: any;
}

function STListing({ data, selected, onSelect, suggested }: STListingProps) {
  const renderItem = useCallback(
    ({ item: stData }) => {
      return (
        <TouchableOpacity activeOpacity={0.8} style={styles.itemContainer} onPress={() => onSelect(stData)}>
          <View style={[styles.itemView, selected?.id === stData?.id ? styles.selected : styles.unselected]}>
            <Radio checked={selected?.id === stData?.id} color="primary" value={1} name="cgt" />
            <View style={{ flex: 1, flexDirection: "row", alignItems: "center" }}>
              <Text style={styles.text}>{stData?.fullName}</Text>
              {/* {stData?.id == suggested && (
              <Badge badgeStyle={styles.suggestionBadge} value={<Text style={styles.badgeText}>Suggested</Text>} />
            )} */}
            </View>

            <View style={{ flex: 1 }}>
              <Text style={[styles.text, { textAlign: "center" }]}>
                {stData?.totalCurrentJoblistsAssignedToTechnician}
              </Text>
            </View>
          </View>
        </TouchableOpacity>
      );
    },
    [selected]
  );

  return (
    <View style={{ maxHeight: "75%" }}>
      <View style={[styles.itemView, { paddingVertical: 0, paddingLeft: 58 }]}>
        <View style={{ flex: 1 }}>
          <Text style={styles.header}>NAME</Text>
        </View>

        <View style={{ flex: 1 }}>
          <Text style={[styles.header, { textAlign: "center" }]}>Total Joblist Assigned</Text>
        </View>

        {/* <View style={{ width: 42 }}></View> */}
      </View>
      <FlatList
        data={data}
        scrollEnabled
        renderItem={renderItem}
        extraData={selected}
        keyExtractor={(item) => item.id.toString()}
        ListEmptyComponent={() => <EmptyListCompnoent emptyListText={"No ST is available to assign"} />}
      />
    </View>
  );
}

const styles = StyleSheet.create({
  itemContainer: {
    cursor: "pointer",
  },
  itemView: {
    flexDirection: "row",
    alignItems: "center",
    marginVertical: 8,
    paddingVertical: 8,
    paddingHorizontal: 16,
    borderRadius: 5,
  },
  selected: {
    backgroundColor: THEME_COLORS.sideMenuBg,
  },
  unselected: {
    border: `1px solid ${THEME_COLORS.sideMenuBg}`,
  },
  header: {
    fontFamily: FONT_FAMILY.semiBoldV3,
    fontSize: 15,
  },
  text: {
    fontSize: 15,
    fontFamily: FONT_FAMILY.primaryV3,
  },
  badgeText: {
    color: THEME_COLORS.white,
    textTransform: "uppercase",
  },
  suggestionBadge: { backgroundColor: THEME_COLORS.purple2, padding: 8, marginLeft: 6, height: 24, borderRadius: 12 },
});

export default React.memo(STListing);
